module.exports = __webpack_public_path__ + "756c1d54c2ec4e0e956752618293a2e5.png";